/**
 * @typedef {"af" | "ax" | "al" | "dz" | "as" | "ad" | "ao" | "ai" | "aq" | "ag" | "ar" | "am" | "aw" | "au" | "at" | "az" | "bs"| "bh" | "bd" | "bb" | "by" | "be" | "bz" | "bj" | "bm" | "bt" | "bo" | "bq" | "ba" | "bw" | "bv" | "br" | "io" | "bn" | "bg" | "bf" | "bi" | "cv" | "kh" | "cm" | "ca" | "ky" | "cf" | "td" | "cl" | "cn" | "cx" | "cc" | "co" | "km" | "cd" | "cg" | "ck" | "cr" | "hr" | "cu" | "cw" | "cy" | "cz" | "ci" | "dk" | "dj" | "dm" | "do" | "ec" | "eg" | "sv" | "gq" | "er" | "ee" | "sz" | "et" | "fk" | "fo" | "fj" | "fi" | "fr" | "gf" | "pf" | "tf" | "ga" | "gm" | "ge" | "de" | "gh" | "gi" | "gr" | "gl" | "gd" | "gp" | "gu" | "gt" | "gg" | "gn" | "gw" | "gy" | "ht" | "hm" | "va" | "hn" | "hk" | "hu" | "is" | "in" | "id" | "ir" | "iq" | "ie" | "im" | "il" | "it" | "jm" | "jp" | "je" | "jo" | "kz" | "ke" | "ki" | "kp" | "kr" | "kw" | "kg" | "la" | "lv" | "lb" | "ls" | "lr" | "ly" | "li" | "lt" | "lu" | "mo" | "mg" | "mw" | "my" | "mv" | "ml" | "mt" | "mh" | "mq" | "mr" | "mu" | "yt" | "mx" | "fm" | "md" | "mc" | "mn" | "me" | "ms" | "ma" | "mz" | "mm" | "na" | "nr" | "np" | "nl" | "nc" | "nz" | "ni" | "ne" | "ng" | "nu" | "nf" | "mp" | "mk" | "no" | "om" | "pk" | "pw" | "ps" | "pa" | "pg" | "py" | "pe" | "ph" | "pn" | "pl" | "pt" | "pr" | "qa" | "re" | "ro" | "ru" | "rw" | "bl" | "sh" | "kn" | "lc" | "mf" | "pm" | "vc" | "ws" | "sm" | "st" | "sa" | "sn" | "rs" | "sc" | "sl" | "sg" | "sx" | "sk" | "si" | "sb" | "so" | "za" | "gs" | "ss" | "es" | "lk" | "sd" | "sr" | "sj" | "se" | "ch" | "sy" | "tw" | "tj" | "tz" | "th" | "tl" | "tg" | "tk" | "to" | "tt" | "tn" | "tr" | "tm" | "tc" | "tv" | "ug" | "ua" | "ae" | "gb" | "us" | "um" | "uy" | "uz" | "vu" | "ve" | "vn" | "vg" | "vi" | "wf" | "eh" | "ye" | "zm" | "zw"} CountryCode
 */


/**
 * @typedef {Object} ICountryLocation
 * @property {number} lat
 * @property {number} lng
 * @property {number} width
 * @property {number} height
 */

/**
 * @typedef {Object.<string, ICountryLocation>} ICountryLocations
 */

window.OSM = window.OSM ?? {};

/**
 * @type {ICountryLocations}
 */
OSM.CountryLocations = {
    ax: {
        // Åland Islands
        lat: 60.26158185811241,
        lng: 20.481262207031254,
        width: 2.57080078125,
        height: 0.8516506336255532
    },
    as: {
    // American Samoa
        lat: -14.270837703067292,
        lng: -169.99145507812503,
        width: 2.57080078125,
        height: 1.660913829778341
    },
    aq: {
    // Antarctica
        lat: -58.4151147,
        lng: 0,
        width: 360,
        height: 30
    },
    aw: {
    // Aruba
        lat: 12.519184105888733,
        lng: -69.96299743652345,
        width: 0.221099853515625,
        height: 0.21550756975248575
    },
    bq: {
    // Bonaire, Sint Eustatius and Saba
        lat: 13.7645583762193,
        lng: -67.71972656250001,
        width: 20.566406250000007,
        height: 13.283724197402012
    },
    bv: {
    // Bouvet Island
        lat: -54.42061197957685,
        lng: 3.3594131469726567,
        width: 0.15552520751953125,
        height: 0.07231151189615304
    },
    cx: {
    // Christmas Island
        lat: -10.494043701297198,
        lng: 105.61946868896486,
        width: 0.201873779296875,
        height: 0.18263085154588943
    },
    cc: {
    // Cocos (Keeling) Islands
        lat: -12.142702954596414,
        lng: 96.86885833740234,
        width: 0.1599884033203267,
        height: 0.17990376483411552
    },
    cw: {
    // Curaçao
        lat: 12.182884511257903,
        lng: -68.89801025390626,
        width: 0.57952880859375,
        height: 0.4778797487381752
    },
    fj: {
    // Fiji
        lat: -17.57761485185214,
        lng: 179.2254638671875,
        width: 4.691162109374972,
        height: 3.5707225629793857
    },
    fr: {
    // France
        lat: 46.68605276211681,
        lng: 1.6040039062500009,
        width: 13.930664062500002,
        height: 9.37145522760116
    },
    gf: {
    // French Guiana
        lat: 3.9164409155368616,
        lng: -53.0584716796875,
        width: 3.504638671874993,
        height: 4.186036645045401
    },
    pf: {
    // French Polynesia
        lat: -16.866739191829893,
        lng: -149.06250000000003,
        width: 5.614013671875,
        height: 2.3075769320448636
    },
    tf: {
    // French Southern Territories
        lat: -48.12388445939492,
        lng: 61.358642578125014,
        width: 19.929199218750007,
        height: 4.162297611096818
    },
    gp: {
    // Guadeloupe
        lat: 16.159603630894722,
        lng: -61.41426086425782,
        width: 0.885772705078125,
        height: 0.7320572179491087
    },
    gu: {
    // Guam
        lat: 13.452283624742702,
        lng: 144.7922515869141,
        width: 0.402374267578125,
        height: 0.47547685025063124
    },
    hm: {
    // Heard Island and McDonald Islands
        lat: -53.081842987688454,
        lng: 73.56307983398439,
        width: 0.68115234375,
        height: 0.2763401755449735
    },
    hk: {
    // Hong Kong
        lat: 22.36257615337612,
        lng: 114.10675048828126,
        width: 0.6536865234375,
        height: 0.4724427869128718
    },
    ki: {
    // Kiribati
        lat: 1.8673336875484565,
        lng: 202.64007568359378,
        width: 0.439453125,
        height: 0.4007872087107036
    },
    mo: {
    // Macao
        lat: 22.1981322991412,
        lng: 113.55666160583496,
        width: 0.059909820556626414,
        height: 0.040211397321460396
    },
    mq: {
    // Martinique
        lat: 14.637243057911267,
        lng: -61.01051330566407,
        width: 0.460052490234375,
        height: 0.5301575364610827
    },
    yt: {
    // Mayotte
        lat: -12.818410088249886,
        lng: 45.15174865722656,
        width: 0.3144836425781179,
        height: 0.4177875759735201
    },
    nl: {
    // Netherlands
        lat: 52.107653714025005,
        lng: 5.29541015625,
        width: 4.394531250000001,
        height: 3.0348835493461763
    },
    nc: {
    // New Caledonia
        lat: -21.09391962366907,
        lng: 166.09680175781253,
        width: 4.669189453125,
        height: 3.627767654778644
    },
    nz: {
    // New Zealand
        lat: -42.568410330148325,
        lng: 174.63867187500003,
        width: 19.9951171875,
        height: 17.35950565781517
    },
    nf: {
    // Norfolk Island
        lat: -29.064696044327402,
        lng: 167.95555114746097,
        width: 0.094757080078125,
        height: 0.14794366798173542
    },
    mp: {
    // Northern Mariana Islands
        lat: 16.513100140539333,
        lng: 145.59082031250003,
        width: 1.47216796875,
        height: 5.24337809558641
    },
    no: {
    // Norway
        lat: 64.37226092064003,
        lng: 17.666015625000004,
        width: 29.882812500000007,
        height: 14.472043202925192
    },
    re: {
    // Réunion
        lat: -21.131622309239965,
        lng: 55.510482788085945,
        width: 0.701751708984375,
        height: 0.5764214885070409
    },
    ru: {
    // Russian Federation
        lat: 59.2237681959095,
        lng: 109.3359375,
        width: 165.5859375,
        height: 37.8214499740572
    },
    bl: {
    // Saint Barthélemy
        lat: 17.916668439781205,
        lng: -62.852611541748054,
        width: 0.14179229736328125,
        height: 0.10388209187685149
    },
    sh: {
    // Saint Helena
        lat: -37.25408763122191,
        lng: -12.466049194335938,
        width: 0.5479431152343732,
        height: 0.41974188308439153
    },
    mf: {
    // Saint Martin (French part)
        lat: 18.08025572815192,
        lng: -63.05997848510742,
        width: 0.19466400146483664,
        height: 0.10509125586570889
    },
    pm: {
    // Saint Pierre and Miquelon
        lat: 46.9517028195085,
        lng: -56.273345947265625,
        width: 0.3405761718749929,
        height: 0.4312137636145721
    },
    sx: {
    // Sint Maarten (Dutch part)
        lat: 18.03423606393465,
        lng: -63.06838989257813,
        width: 0.1263427734375,
        height: 0.06790282036629236
    },
    sj: {
    // Svalbard and Jan Mayen
        lat: 78.59679054595293,
        lng: 21.785888671875004,
        width: 24.499511718750007,
        height: 4.5520733382078475
    },
    tv: {
    // Tuvalu
        lat: -8.533982058462696,
        lng: 179.12744522094727,
        width: 0.17337799072262783,
        height: 0.23664630453018987
    },
    us: {
    // United States
        lat: 39.7837304,
        lng: -100.445882,
        width: 61.611328125,
        height: 26.976711459588163
    },
    um: {
    // United States Minor Outlying Islands
        lat: 32.40095524182467,
        lng: 193.62304687500003,
        width: 74.00390625,
        height: 56.37202420086804
    },
    vi: {
    // Virgin Islands, U.S.
        lat: 18.02925873304939,
        lng: -64.80010986328126,
        width: 0.54107666015625,
        height: 0.7600040524746952
    },
    wf: {
    // Wallis and Futuna
        lat: -13.802558625369128,
        lng: -177.17239379882812,
        width: 2.1670532226562216,
        height: 1.2589233897110894
    }
}